const AuthRoles = {
  admin: ["admin"],
  user: ["admin", "user"],
  onlyGuest: [],
};

export default AuthRoles;
